"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconSocialTwitter = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconSocialTwitter = function IconSocialTwitter(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24 4.368a9.638 9.638 0 01-2.828.794 5.036 5.036 0 002.165-2.793 9.734 9.734 0 01-3.127 1.226A4.858 4.858 0 0016.616 2c-3.179 0-5.515 3.041-4.797 6.199-4.091-.21-7.719-2.22-10.148-5.275-1.29 2.27-.669 5.238 1.523 6.741a4.808 4.808 0 01-2.229-.632c-.054 2.34 1.581 4.528 3.949 5.015a4.81 4.81 0 01-2.224.086c.626 2.006 2.444 3.465 4.6 3.506A9.726 9.726 0 010 19.732 13.693 13.693 0 007.548 22c9.142 0 14.307-7.917 13.995-15.018A10.178 10.178 0 0024 4.368z"
  }));
};
exports.IconSocialTwitter = IconSocialTwitter;